import React, {Component} from 'react'
import './import-delivery-detail.less'
import './track.less'
import {message, } from 'antd'
import {baseUrl, getImportOrderShort} from '../../api'
import axios from 'axios'
import ImportDeliveryStep from '../import-delivery-step/import-delivery-step'
import ImportBoxInfoView from './import-box-info-v'
import ImportTrackShortInfo from './import-track-short-info-v'
import ImportVehicleDriver from "./import-vehicle-driver"
import ImportOrderTrain from "./import-order-train"
class ImportDeliveryDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            entName:'',
            order: {},
            boxInfo: {},
            orderId: props.location.state.orderId,
        }
    }
    componentDidMount() {
        let orderId = this.props.location.state.orderId
        this.getOrderDetail(orderId);
        axios.get(baseUrl + '/api/v1/p/oms/importOrderDelivery/detail', { // 配置对象
            params: {orderId} // 指定请求参数
        }).then((res) => {
            let result = res.data;
            if (result.code === 200) {
                this.setState({
                    boxInfo: result.data,
                })
            } else {
                message.error(result.message)
                return false;
            }
        });
    }

    // 查询详情
    getOrderDetail = async (id) => {
        let result = await getImportOrderShort(id)
        if (result.code === 200) {
            this.setState({order: result.data.orderDo, entName: result.data.entName})
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {
            message.error(result.message)
        }
    }

    render() {
        const {order, boxInfo, entName, orderId} = this.state;
        return (
            <div className='order-info info box-shadow padding-20'>
                <div className="head-title">
                    <span className='title'>进口物流详情</span>
                </div>
                <br/>
                <ImportTrackShortInfo order={order} entName={entName}/>
                <div className='info-item'>
                    <div className="info-item-title">
                        轨迹信息
                    </div>
                    <div className="info-item-content">
                        <ImportDeliveryStep {...this.props}/>
                    </div>
                    {order.entrustType === 'p2d' ? null :
                        <div className="info-item-title">
                        <div className='flex-between'>
                            <div>车辆信息</div>
                        </div>
                    </div>}
                    {order.entrustType === 'p2d' ? null :
                        <div className="info-item-content">
                            <div className="info-item-content flex-between">
                                {order.deliveryType === 'YIT' ?
                                    <ImportVehicleDriver orderId={orderId} type="O"/>
                                    : null}
                                {order.deliveryType === 'YIN' ?
                                    <ImportOrderTrain order={order}/>
                                    : null}
                                {order.deliveryType === 'YIN' || order.deliveryType === 'YIT' ?
                                    <ImportVehicleDriver entrustType={order.entrustType} orderId={orderId} type="I" />
                                    : null}
                            </div>
                        </div>
                    }
                    <br/>
                    {order.entrustType === 'p2d' ? null :
                    <div className="info-item-title">
                        发车信息
                    </div>}
                    {order.entrustType === 'p2d' ? null :
                        <div className="info-item-content">
                        <ImportBoxInfoView entrustType={order.entrustType} boxInfo={boxInfo}/>
                        </div>}
                </div>
            </div>

        )
    }
};
export default ImportDeliveryDetail